import React from "react";
import { Container, Row, Col } from "shards-react";
import BookingTelepaseToll from "../components/common/bookings/BookingTelepaseToll";

const BookingTelepaseTollsView = props => {
  const { id } = props.match.params;
  return (
    <Container fluid className="main-content-container">
      <BookingTelepaseToll id={id} />
    </Container>
  );
};

export default BookingTelepaseTollsView;
